import { combineReducers } from '@reduxjs/toolkit';
import customHjelpetekster, {} from './custom-hjelpetekster';
import hjelpeskuff, {} from './hjelpeskuff';
const prosesshjelp = combineReducers({
    hjelpeskuff,
    customHjelpetekster,
});
export default prosesshjelp;
